// Shared option lists for the Customer record.
export const INDUSTRIES = [
  "Retail", "Wholesale / Distribution", "Manufacturing", "Construction",
  "Electrical & Electronics", "Hardware & Tools", "Automotive", "FMCG",
  "Textiles & Apparel", "Pharmaceuticals", "Chemicals", "Agriculture",
  "Hospitality", "Healthcare", "Education", "IT & Software",
  "Logistics & Transport", "Real Estate", "Services", "Other",
];

export const EMPLOYEE_SIZES = ["1-10", "11-50", "51-200", "201-500", "501-1000", "1000+"];

export const CONTACT_TITLES = ["Mr.", "Mrs.", "Ms.", "Dr.", "Er.", "M/s."];
